/**
 * Code Generators Services Module
 * Exports all code generation services and factory functions
 */
// Service exports
export * from './BarcodeService';
export * from './QrCodeService';
export * from './UtilityCodeService';
export * from './GeneratedCodeService';
export * from './QrCodeManagementService';
export * from './QrCodeAssetService';
export * from './QrCodeFrameService';
// Service imports for factory
import { BarcodeService } from './BarcodeService';
import { QrCodeService } from './QrCodeService';
import { UtilityCodeService } from './UtilityCodeService';
import { GeneratedCodeService } from './GeneratedCodeService';
import { QrCodeManagementService } from './QrCodeManagementService';
import { QrCodeAssetService } from './QrCodeAssetService';
import { QrCodeFrameService } from './QrCodeFrameService';
/**
 * Create all code generator services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all generator service instances
 */
export function createGeneratorsServices(http, config) {
    return {
        barcode: new BarcodeService(http, config),
        qrCode: new QrCodeService(http, config),
        utilityCode: new UtilityCodeService(http, config),
        generatedCode: new GeneratedCodeService(http, config),
        qrCodeManagement: new QrCodeManagementService(http, config),
        qrCodeAsset: new QrCodeAssetService(http, config),
        qrCodeFrame: new QrCodeFrameService(http, config),
    };
}
//# sourceMappingURL=index.js.map